
export default function Pagination({ total, perPage, page, setPage }) {
    // const [page, setPage] = useState(1);

    const totalPages = Math.ceil(total / perPage);
    const start = (page - 1) * perPage + 1;
    const end = Math.min(page * perPage, total);

    const getPages = () => {
        if (totalPages <= 7) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }

        if (page <= 4) {
            return [1, 2, 3, 4, 5];
        }

        if (page >= totalPages - 3) {
            return [
                totalPages - 4,
                totalPages - 3,
                totalPages - 2,
                totalPages - 1,
                totalPages,
            ];
        }

        return [page - 1, page, page + 1];
    };

    const pages = getPages();

    return (
        <div className="custom_pagination">
            <div className="dt-info">
                Showing {start} to {end} of {total.toLocaleString()} entries
            </div>

            <div className="dt-pagination">
                <button
                    disabled={page === 1}
                    onClick={() => setPage(p => p - 1)}
                >
                    Previous
                </button>

                {pages[0] > 1 && (
                    <>
                        <button onClick={() => setPage(1)}>1</button>
                        <span>…</span>
                    </>
                )}

                {pages.map(p => (
                    <button
                        key={p}
                        className={p === page ? "active" : ""}
                        onClick={() => setPage(p)}
                    >
                        {p}
                    </button>
                ))}

                {pages[pages.length - 1] < totalPages && (
                    <>
                        <span>…</span>
                        <button onClick={() => setPage(totalPages)}>
                            {totalPages}
                        </button>
                    </>
                )}

                <button
                    disabled={page === totalPages}
                    onClick={() => setPage(p => p + 1)}
                >
                    Next
                </button>
            </div>
        </div>
    );
}
